import React from "react"
import { useSelector } from "react-redux"
import { getClockFormat } from "reduxSlices/currentSettingsSlice"
import { auditItemDetailsComponent } from "utils/auditHelper"
import { orgLocalDateTimeByClockFormat } from "utils/dateHelpers"
import { CLOCK_FORMAT_TWELVE_HOUR_SETTING } from "utils/generalSettingsHelpers"
import { auditShape } from "utils/propTypeShapes"
import { ProfileIcon } from "shared/icons"
import * as FacilityAuditItemDetails from "views/Facilities/FacilityTabs/AuditTrailTab/AuditItem/AuditItemDetails"

const AuditItem = ({ audit }) => {
  const AuditItemDetailsComponent = auditItemDetailsComponent(audit, FacilityAuditItemDetails)
  const clockFormat = useSelector(getClockFormat)

  const widerTimeFormat = clockFormat === CLOCK_FORMAT_TWELVE_HOUR_SETTING
  const dateColumnPixels = widerTimeFormat ? "190px" : "177px"
  const tracking = widerTimeFormat ? "tracking-tighter" : "tracking-tight"

  return (
    <div
      className="border rounded-lg border-light-300 bg-primary-light mb-6 p-3 text-sm grid"
      style={{ gridTemplateColumns: `44px 1fr ${dateColumnPixels}` }}
    >
      <ProfileIcon className="w-8 h-8 mr-3" user={audit.user} />
      <AuditItemDetailsComponent audit={audit} />
      <span className={`font-medium justify-self-end ${tracking}`}>
        { orgLocalDateTimeByClockFormat(audit.createdAt, clockFormat) }
      </span>
    </div>
  )
}

AuditItem.propTypes = {
  audit: auditShape.isRequired,
}

export default AuditItem
